import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE = "https://eluvent.com/api";

const RequireAuth = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/auth/user`, { withCredentials: true })
      .then(res => {
        if (res.data && res.data.id) setUser(res.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ textAlign: "center", padding: 40 }}>Checking authentication…</div>;

  if (!user) {
    const currentUrl = window.location.pathname + window.location.search;
    return (
      <div style={{ maxWidth: 400, margin: "60px auto", textAlign: "center", fontFamily: "Nunito, sans-serif" }}>
        <h2>🔐 Sign in required</h2>
        <p>You need to sign in to access this feature.</p>
        <a
          href={`https://eluvent.com/auth/google/login?next=${encodeURIComponent(currentUrl)}`}
          style={{
            display: "inline-block",
            padding: "12px 24px",
            background: "#fca311",
            color: "white",
            borderRadius: 30,
            fontWeight: 700,
            textDecoration: "none",
            marginTop: 16
          }}
        >
          Sign in with Google
        </a>
      </div>
    );
  }

  return children;
};

export default RequireAuth;